define('modules/campaigns/campaigns_view',[
  'backbone',
  'jquery',
  '_',
  'modules/modal/modal_view',

  './collections/campaigns_collection',

  './campaigns_ad_model',
  'modules/htmlad/player/htmlad_player_view',

  'modules/list/list_view',
  'modules/loading/loading_spinner_view',
  'modules/pagination/pagination_view',

  'modules/campaigns/modal/play_ad_modal',
  'modules/campaigns/modal/pause_ad_modal',

  'text!./campaigns_template.html',
  'text!./collections/central_campaigns/central_campaign_header_template.html',
  'text!./collections/central_campaigns/central_campaign_list_item_template.html',
  'text!./collections/local_campaigns/local_campaign_header_template.html',
  'text!./collections/local_campaigns/local_campaign_list_item_template.html',

  './modal/add_zones_modal_view',
  './modal/remove_zones_modal_view',
  './modal/play_selected_modal_view',
  './modal/pause_selected_modal_view',
  
  './campaigns_helper',
  'session'
], function (Backbone, $, _,
             ModalView,
             CampaignsCollection,
             AdModel,
             HtmlAdPlayer,
             ListView,
             Loading,
             PaginationView,
             PlayAdModal,
             PauseAdModal,
             weekly_offers_template,
             central_campaign_header_template,
             central_campaign_list_item_template,
             local_campaign_header_template,           
             local_campaign_list_item_template,
             AddZonesModal,
             RemoveZonesModal,
             PlaySelectedModal,
             PauseSelectedModal,
             CampaignsHelper,
             session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {

      _.extend(this, opts);

      this.pagination = false;
      this.collection = null;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = CampaignsCollection;
      
      this.listenTo(this.collection, 'request', loading.start.bind(loading));

      this.listenTo(this.collection, 'destroy', function (collection) {
        loading.done();
      }, this);

      this.listenTo(this.collection, 'sync', function (collection) {
        loading.done();

        // Ugly code to refetch if the results from one tab come before the other.
        // Bug 4802 (BTV- Kampanjer- kampanjer visas inte)
        if (collection.params.campaignPeriod !== this.filterParams.campaignPeriod) {
          this.fetchOffers();
          return;
        }

        $('.js-campaign-loader').first().addClass('is-hidden');

        this.renderList();
        this.resetCheckBoxes();
        this.renderHeader();
        this.renderPagination();

      }, this);

      Backbone.on('campaigns:addzones', this.modifyZones, this);
      Backbone.on('campaigns:removezones', this.modifyZones, this);
      Backbone.on('campaigns:modifystatus', this.modifyStatuses, this);
      Backbone.on('pagination:fetch', this.fetchOffers, this);
      Backbone.on('campaigns:playads', this.playAds, this);
      Backbone.on('campaigns:pauseads', this.pauseAds, this);
      // Not fetching offers because the first filtermodel fetch will trigger a collection fetch
      // this.fetchOffers();

    },

    filterParams: [], // Get populated from filterModel change callback on the parent page.
    zoneList: [], // Get populated from filterModel change callback on the parent page.

    hasSidebar: false,
    subViews: [],

    template: _.template(weekly_offers_template),
    header_template: _.template(central_campaign_header_template),
    item_template: _.template(central_campaign_list_item_template),
    
    events: {
      'click .js-header-checkbox': 'selectAllBookings',
      'click .js-item-checkbox': 'onSelectBooking',
      'click .js-preview-ad': 'previewAd',
      'click .js-item-play-ad': 'openPlayAdModal',
      'click .js-header-play-ads': 'openPlayAdsModal',
      'click .js-item-pause-ad': 'openPauseAdModal',
      'click .js-header-pause-ads': 'openPauseAdsModal',
      'click .js-header-add-zones': 'openAddZonesModal',
      'click .js-header-remove-zones': 'openRemoveZonesModal',
      'click .js-header-play-selected': 'openPlaySelectedModal',
      'click .js-header-pause-selected': 'openPauseSelectedModal',
      'click .js-item-playing-checkbox': 'onStatusChange',
      'click .campaign-header-item.is-sortable': 'onSortOrderChange'
    },

    onSortOrderChange: function(e) {

      var that = this;
      var orderData = e.currentTarget.dataset;

      _.forEach($('.campaign-header-item.is-sortable'), function(element) {

        if (element.dataset.orderBy === orderData.orderBy) {

          element.classList.add('is-active');
          
          if (element.classList.contains('is-asc')) {
            element.classList.remove('is-asc');
            element.classList.add('is-desc');
          }
          else {
            element.classList.remove('is-desc');
            element.classList.add('is-asc');
          }

          // console.log(' element.classList',  element.classList);

          that.collection.params.order_by = orderData.orderBy;
          that.collection.params.order = element.classList.contains('is-asc') ? 'ASC' : 'DESC';

        } else {
          element.classList.remove('is-active', 'is-asc', 'is-desc');
        }
      });
      
      this.fetchOffers();
    },

    modifyStatuses: function(status) {
      if (!this.collection || !this.collection.models || !status) { return false; }

      var loading = new Loading();
      loading.start();

      // Work only on the models that are selected.
      var checkedModels = _.filter(this.collection.models, function(item) {
        return item.get('isChecked') === true;
      });

      var bookingIds = _.map(checkedModels, function(item) {
        return item.get('bookingId');
      });

      var payload = {
        'bookingIds': bookingIds,
        'isPlaying': status === 'play'
      };

      $.ajax({
        type: 'PUT',
        url: session.get('apiUrl') + 'campaignstatuses',
        data: payload,
        dataType: 'json'
      })
      .complete(function (data) {
        // console.log('modify statuses ok callback');
        loading.done();
        this.fetchOffers();
      }.bind(this));

    },

    modifyZones: function(modalInfo) {

      // console.log('modifyZones - modalInfo', modalInfo);

      var loading = new Loading();
      loading.start();

      var affectedBookings = [];

      _.forEach($('.js-item-checkbox'), function(inputElement) {
        if (inputElement.checked) {
          affectedBookings.push(inputElement.dataset.id);
        }
      });

      // console.log('zones added', zones.activeZones);
      // console.log('collections affected', affectedBookings);

      if (modalInfo.selectedZones &&
          modalInfo.selectedZones.length > 0 &&
          affectedBookings &&
          affectedBookings.length > 0) {

        var payload = {
          operationType: modalInfo.operationType,
          zoneCodes: modalInfo.selectedZones,
          bookingCodes: affectedBookings
        };

        $.ajax({
          type: 'PUT',
          // contentType: 'application/json; charset=UTF-8',
          url: session.get('apiUrl') + 'campaignzones',
          data: payload,
          dataType: 'json'
        }).success(function (data) {
          console.log('modify zones ok callback');
          loading.done();
          this.fetchOffers();
        }.bind(this))
        .error(function(error) {
          loading.done();
          this.fetchOffers();
        }.bind(this));
      }

    },

    playAds: function (modalInfo) {
      var loading = new Loading();
      this.subViews.push(loading);
      loading.start();
      this.hideCampaignsPageContent();

      $.ajax({
        type: 'POST',
        url: session.get('apiUrl') + 'bookings/removeblacklistlocations',
        data: JSON.stringify({
          booking_ids: modalInfo.bookingIds,
          location_code: modalInfo.locationCode,
          end_date: undefined
        }),
        contentType: 'application/json'
      })
        .success(function (data) {
          console.info(data);
          loading.done();
          this.fetchOffers();
          this.showCampaignsPageContent();
        }.bind(this))
        .error(function (error) {
          console.error(error);
          loading.done();
          this.showCampaignsPageContent();
        }.bind(this));
    },

    pauseAds: function (modalInfo) {
      var loading = new Loading();
      this.subViews.push(loading);
      loading.start();
      this.hideCampaignsPageContent();

      $.ajax({
        type: 'POST',
        url: session.get('apiUrl') + 'bookings/addblacklistlocations',
        data: JSON.stringify({
          booking_ids: modalInfo.bookingIds,
          location_code: modalInfo.locationCode,
          end_date: modalInfo.endDate.toString()
        }),
        contentType: 'application/json'
      })
        .success(function (data) {
          console.info(data);
          loading.done();
          this.fetchOffers();
          this.showCampaignsPageContent();
        }.bind(this))
        .error(function (error) {
          console.error(error);
          loading.done();
        }.bind(this));
    },

    hideCampaignsPageContent: function () {
      $('.campaigns-page-content').css('display', 'none');
    },

    showCampaignsPageContent: function () {
      $('.campaigns-page-content').css('display', '');
    },

    openPlayAdModal: function (e) {
      e.preventDefault();

      var bookingId = parseInt(e.currentTarget.getAttribute('data-booking-id'));
      var userLocationCode = e.currentTarget.getAttribute('data-user-location-code');

      var modalView = new ModalView({
        title: _.t('campaigns.central_campaign.play_ad_modal.titel'),
        modalContent: new PlayAdModal({
          bookingIds: [bookingId],
          locationCode: userLocationCode
        }),
        bottom_toolbar: false
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    openPlayAdsModal: function (e) {
      e.preventDefault();

      var selectedBookingIds = [];
      var userLocationCode = '';
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          selectedBookingIds.push(parseInt(element.dataset.bookingId));
          userLocationCode = element.dataset.userLocationCode;
        }
      });

      var modalView = new ModalView({
        title: selectedBookingIds.length > 1 ?_.t('campaigns.central_campaign.play_ads_modal.titel') : _.t('campaigns.central_campaign.play_ad_modal.titel'),
        modalContent: new PlayAdModal({
          bookingIds: selectedBookingIds,
          locationCode: userLocationCode
        }),
        bottom_toolbar: false
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    openPauseAdModal: function (e) {
      e.preventDefault();

      var bookingId = parseInt(e.currentTarget.getAttribute('data-booking-id'));
      var userLocationCode = e.currentTarget.getAttribute('data-user-location-code');

      var modalView = new ModalView({
        title: _.t('campaigns.central_campaign.pause_ad_modal.titel'),
        modalContent: new PauseAdModal({
          bookingIds: [bookingId],
          locationCode: userLocationCode
        }),
        bottom_toolbar: false
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    openPauseAdsModal: function (e) {
      e.preventDefault();

      var selectedBookingIds = [];
      var userLocationCode = '';
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          selectedBookingIds.push(parseInt(element.dataset.bookingId));
          userLocationCode = element.dataset.userLocationCode;
        }
      });

      var modalView = new ModalView({
        title: selectedBookingIds.length > 1 ?_.t('campaigns.central_campaign.pause_ads_modal.titel') : _.t('campaigns.central_campaign.pause_ad_modal.titel'),
        modalContent: new PauseAdModal({
          bookingIds: selectedBookingIds,
          locationCode: userLocationCode
        }),
        bottom_toolbar: false
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    openAddZonesModal: function(e) {

      // Find out which zones selected by all the items
      var fieldsModel = {
        all: {
          label: _.t('campaigns.modal.addzones.select_all_checkbox'),
          name: 'all',
          state: '',
          value: 'all'
        },
        options: [],
        readonly: false
      };

      for (var i = 0; i < this.zoneList.length; i++) {
        var zone = this.zoneList[i];
        
        var fieldObject = {
          value: zone.value,
          label: zone.text,
          state: ''
        };

        var zoneInEveryItem = CampaignsHelper.everyItemInCollectionHasZone(this.collection, zone.value);
        if (zoneInEveryItem) {
          fieldObject.state = 'active disabled';
        }

        fieldsModel.options.push(fieldObject);
      }

      var modal = new ModalView({
        title: _.t('campaigns.modal.addzones.header'),
        modalContent: new AddZonesModal({fields: fieldsModel}),
        bottom_toolbar: false
      });

      modal.open();
    },

    openRemoveZonesModal: function(e) {

      // Find out which zones are selected by none of the items
      var fieldsModel = {
        all: {
          label: _.t('campaigns.modal.removezones.select_all_checkbox'),
          name: 'all',
          state: '',
          value: 'all'
        },
        options: [],
        readonly: false
      };

      for (var i = 0; i < this.zoneList.length; i++) {
        var zone = this.zoneList[i];
        
        var fieldObject = {
          value: zone.value,
          label: zone.text,
          state: ''
        };

        var zoneInEveryItem = CampaignsHelper.everyItemInCollectionNotHaveZone(this.collection, zone.value);
        if (zoneInEveryItem) {
          fieldObject.state = 'active disabled';
        }

        fieldsModel.options.push(fieldObject);
      }

      var modal = new ModalView({
        title: _.t('campaigns.modal.removezones.header'),
        modalContent: new RemoveZonesModal({fields: fieldsModel}),
        bottom_toolbar: false
      });

      modal.open();
    },

    openPlaySelectedModal: function() {
      var modal = new ModalView({
        title: _.t('campaigns.modal.playselected.header'),
        modalContent: new PlaySelectedModal(),
        bottom_toolbar: false
      });

      modal.open();
    },

    openPauseSelectedModal: function() {
      var modal = new ModalView({
        title: _.t('campaigns.modal.pauseselected.header'),
        modalContent: new PauseSelectedModal(),
        bottom_toolbar: false
      });

      modal.open();
    },

    onSelectBooking: function(e) {

      // Used for setting the isChecked true/false for the add/remove modal
      var targetModel = this.collection.find(function(model) {
        return model.get('bookingCode') === e.currentTarget.dataset.id;
      });
      targetModel.set('isChecked', !targetModel.get('isChecked'));


      var numberItemChecked = 0;

      _.forEach($('.js-item-checkbox'), function(inputElement) {
        if (inputElement.checked) {
          numberItemChecked++;
        }
      });

      // Update allSelect checkbox state
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) { return; }
      headerCheckbox.prop('checked', numberItemChecked >= 1);

      var payload = {
        isChecked: numberItemChecked >= 1,
        numberOfItems: numberItemChecked
      };

      // console.log('payload multi item', payload);
      this.renderHeader(payload);
      
    },

    selectAllBookings: function() {
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) { return; }

      var isChecked = headerCheckbox.prop('checked'); //= !headerCheckbox.checked;

      this.collection.each(function (model) {
        model.set('isChecked', isChecked);
      }, this);

      _.forEach($('.js-item-checkbox'), function(inputElement) {
        inputElement.checked = isChecked;
      });

      // Not going to renderList because it rerenders everything and causes a flash
      // this.renderList();

      var payload = {
        isChecked: isChecked,
        numberOfItems: this.collection.length
      };

      // console.log('payload all select', payload);
      this.renderHeader(payload);
    },

    previewAd: function(e) {
      // console.log('previewAd', e.currentTarget);

      var self = this;
      // var $ad;
      var ad_id;
      var adModel;

      e.preventDefault();

      ad_id = e.currentTarget.dataset.adId;
      // console.log('ad_id', ad_id);

      if (!ad_id) { return; }

      adModel =  new AdModel({id: ad_id});

      this.listenToOnce(adModel, 'sync', function (model) {

        // console.log('adModel sync', model);

        var previewModel;
        var htmlAdPlayer; 

        previewModel = new Backbone.Model({
          name: model.get('title'),
          preview: model.get('preview_url'),
          metadata: {
            orientations: model.get('orientations')
          }
        });
        htmlAdPlayer = new HtmlAdPlayer({
          model: previewModel,
          fitHeight: 600,
          close: function () {
            self.$('.js-preview-iframe').removeClass('ad-preview').empty();
            this.remove();

          }
        });

        this.$('.js-preview-iframe').html(htmlAdPlayer.$el).addClass('ad-preview');

      }, this);

      adModel.fetch();

    },

    fetchOffers: function() {

      if (!this.collection ||
          !this.collection.params ||
          Number.isNaN(this.collection.params.offset)) {
        return;
      }

      var payload = {
        campaignPeriod: this.filterParams.campaignPeriod || 'all',
        zoneOptions: this.filterParams.zoneOptions || [],
        searchText: this.filterParams.searchText || '',
        metadata: this.collection.params || null
      };

      this.render();

      $('.js-campaign-loader').first().removeClass('is-hidden');

      this.collection.fetch({ 
        type: 'POST',
        data: payload
      });

    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderHeader: function (payload) {

      var templateInfo = {
        order_by: '',
        order: '',
        isChecked: false,
        numberOfItems: 0
      };
      
      if (payload != null && payload.isChecked === true) {
        templateInfo.isChecked = payload.isChecked;
        templateInfo.numberOfItems = payload.numberOfItems;
      }

      if (this.collection && this.collection.params) {
        templateInfo.order_by = this.collection.params.order_by;
        templateInfo.order = this.collection.params.order;
      }

      this.$('.js-weekly-offers-header').html(this.header_template(templateInfo));
      return this;
    },

    renderList: function () {

      var items = []; 
      var weeklyOffersList;

      this.collection.each(function (model) {

        if (!model.get('isChecked')) { model.set('isChecked', false); }

        items.push({value: this.item_template(model.toJSON())});
      }, this);

      weeklyOffersList = new ListView({
        items: items,
        options: {
          search: false
        }
      });


      this.$('.js-weekly-offers-list').html(weeklyOffersList.$el);

      this.subViews.push(weeklyOffersList);

      return this;
    },

    renderPagination: function () {

      if (this.pagination) {
        this.pagination.remove();
      }

      this.pagination = new PaginationView(this.collection, { useEventTriggerToInvokeRefresh: true });
      this.subViews.push(this.pagination);
      
      this.$('.js-weekly-offers-pagination').html(this.pagination.$el);
      this.pagination.delegateEvents();
    },

    resetCheckBoxes: function() {
      var headerCheckbox = $('.js-header-checkbox');

      if (!headerCheckbox) { return this; }

      headerCheckbox.prop('checked', false);
      
      this.collection.each(function (model) {
        model.set('isChecked', false);
      }, this);

      _.forEach($('.js-item-checkbox'), function(inputElement) {
        inputElement.checked = false;
      });

      return this;
    },

    onStatusChange: function(e) {

      var bookingId =  e.currentTarget.dataset.id;

      var payload = {
        'bookingIds': [bookingId],
        'isPlaying': e.currentTarget.checked
      };

      $.ajax({
        type: 'PUT',
        url: session.get('apiUrl') + 'campaignstatuses',
        data: payload,
        dataType: 'json'
      })
      .success(function (data) {
        // console.log('modify status ok callback');
      }.bind(this))
      .error(function(error) {
        this.fetchOffers();
      }.bind(this));
    },

    remove: function () {

      Backbone.off('campaigns:addzones');
      Backbone.off('campaigns:removezones');
      Backbone.off('campaigns:playads');
      Backbone.off('campaigns:pauseads');

      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

